import PropTypes from 'prop-types'
import { useMemo } from 'react'
import { PaginatedLoadingTable, Text } from '@artprov/design-system'

export const TablaTopTen = ({ title, data, isLoading, columns }) => {
  // Procesar los datos aplicando formatters si existen en las columnas
  const formattedData = useMemo(() => {
    if (!data || data.length === 0) return data

    return data.map((row) => {
      const formattedRow = { ...row }

      columns.forEach((column) => {
        if (column.formatter && formattedRow[column.key] !== undefined) {
          formattedRow[column.key] = column.formatter(formattedRow[column.key])
        }
      })

      return formattedRow
    })
  }, [data, columns])

  return (
    <div>
      <Text variant="h7" className="mt-6 mb-5 text-primary-10">
        {title}
      </Text>
      {isLoading ? (
        <div className="rounded-md p-4 bg-tertiary-98">
          <div className="flex justify-center items-center py-12">
            <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-blue-primary"></div>
          </div>
        </div>
      ) : (
        <PaginatedLoadingTable
          data={formattedData}
          columns={columns}
          header={{}}
          selectable={false}
          showPagination={false}
          uniqueKey="ex_cuil"
          emptyState={{ icon: '', title: 'Sin datos para mostrar' }}
        />
      )}
    </div>
  )
}

TablaTopTen.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  columns: PropTypes.array.isRequired,
}
